var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCorruptIcon = function SvgCorruptIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 13 5.5M0 3v10c0 .55.45 1 1 1h6v-1H1.002L1 12.998V3.002L1.002 3H7V2H1c-.55 0-1 .45-1 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H9V0H8v16h1v-2h6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m0 10.998-.002.002H9v-1h5V7l-3.5 3h-1L9 9.375V3h5.998l.002.002zM2 11v1h5V6.875L5.5 5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCorruptIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;